import { Index } from '@piconetworks/login'

import withInjection from '@piconetworks/with-injection'

import Internal from 'common/modules/internal'
import Router from 'common/modules/router'
import xFrame from 'common/xFrame'

import WizardRedux from 'common/pkgs/WizardRedux'

const mapStateToProps = (state, props) => {
    const {
        id: wizardName,
        short_code,
        asPath,
        pathname,
        submitActionType,
        submitPayload,
    } = props.router.query

    let submitPayloadParsed = {
        url: {
            pathname: '/login',
            query: {
                ...(wizardName && { id: wizardName }),
                ...(asPath && { asPath }),
                ...(pathname && { pathname }),
                ...(short_code && { short_code }),
            },
        },
        as: {
            pathname: '/login',
            query: {
                ...(wizardName && { id: wizardName }),
                ...(asPath && { asPath }),
                ...(pathname && { pathname }),
                ...(short_code && { short_code }),
            },
        },
        userEmail: null,
    }

    if (submitPayload) {
        try {
            submitPayloadParsed = JSON.parse(submitPayload)
        } catch (error) {
            // do nothing
        }
    }

    return {
        ...props,
        submitActionType: submitActionType || Router.types.REPLACE,
        submitPayload: submitPayloadParsed,
        WizardRedux,
    }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
    onHasAccessToken: ({ form }) => {
        dispatch(Internal.creators.loaderInvalidationEvent({
            payload: {
                scope: [
                    'user',
                ],
            },
        }))

        const wizardName = ownProps?.router?.query?.id
        if (wizardName) {
            form.submit()
        } else {
            xFrame.prompt.showMenu({ dispatch })
        }
    },
})

const InjectedIndex = withInjection(Index, {
    mapStateToProps,
    mapDispatchToProps,
})

export default InjectedIndex
